'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AccountId$() {
  this.c4K = null;
  this.c4L = false;
  this.c4I = null;
  this.c4J = false;
}
export { $c_Lpresto_types$AccountId$ as $c_Lpresto_types$AccountId$ };
$p = $c_Lpresto_types$AccountId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AccountId$;
/** @constructor */
function $h_Lpresto_types$AccountId$() {
}
export { $h_Lpresto_types$AccountId$ as $h_Lpresto_types$AccountId$ };
$h_Lpresto_types$AccountId$.prototype = $p;
$p.a35 = (function() {
  if ((!this.c4L)) {
    this.c4K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.c4L = true;
  }
  return this.c4K;
});
$p.bl = (function() {
  if ((!this.c4J)) {
    this.c4I = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.c4J = true;
  }
  return this.c4I;
});
var $d_Lpresto_types$AccountId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AccountId$, "presto.types$AccountId$", ({
  Yx: 1,
  D: 1
}));
export { $d_Lpresto_types$AccountId$ as $d_Lpresto_types$AccountId$ };
var $n_Lpresto_types$AccountId$;
function $m_Lpresto_types$AccountId$() {
  if ((!$n_Lpresto_types$AccountId$)) {
    $n_Lpresto_types$AccountId$ = new $c_Lpresto_types$AccountId$();
  }
  return $n_Lpresto_types$AccountId$;
}
export { $m_Lpresto_types$AccountId$ as $m_Lpresto_types$AccountId$ };
//# sourceMappingURL=presto.types$-Account-Id$.js.map
